import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PercentIcon from '@mui/icons-material/Percent';
import EventNoteIcon from '@mui/icons-material/EventNote';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SellIcon from '@mui/icons-material/Sell';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import StarIcon from '@mui/icons-material/Star';
import CallIcon from '@mui/icons-material/Call';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import EmailIcon from '@mui/icons-material/Email';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { PricingIconTypes } from '../../types/enums';

export const PricingIcons = {
  [PricingIconTypes.accessTimeIcon]: AccessTimeIcon,
  [PricingIconTypes.checkCircleIcon]: CheckCircleIcon,
  [PricingIconTypes.percentIcon]: PercentIcon,
  [PricingIconTypes.eventNoteIcon]: EventNoteIcon,
  [PricingIconTypes.addCircleIcon]: AddCircleIcon,
  [PricingIconTypes.shoppingCartIcon]: ShoppingCartIcon,
  [PricingIconTypes.sellIcon]: SellIcon,
  [PricingIconTypes.lightbulbIcon]: LightbulbIcon,
  [PricingIconTypes.accountCircleIcon]: AccountCircleIcon,
  [PricingIconTypes.starIcon]: StarIcon,
  [PricingIconTypes.callIcon]: CallIcon,
  [PricingIconTypes.autorenewIcon]: AutorenewIcon,
  [PricingIconTypes.eventBusyIcon]: EventBusyIcon,
  [PricingIconTypes.creditCardIcon]: CreditCardIcon,
  [PricingIconTypes.emailIcon]: EmailIcon,
  [PricingIconTypes.checkIcon]: CheckIcon,
  [PricingIconTypes.closeIcon]: CloseIcon,
};
